export default {
    countLineBreaks(text) {
        return (text.match(/\n/g) || []).length;
    }
}